// extracted by mini-css-extract-plugin
module.exports = {"tip":"index_tip_2vQQq","title":"index_title_35w_E","hint":"index_hint_1xUc4","title_text":"index_title_text_1Fene"};